import { render, staticRenderFns } from "./SuccessComponent.vue?vue&type=template&id=1f7a28ba&scoped=true"
import script from "./SuccessComponent.vue?vue&type=script&lang=ts"
export * from "./SuccessComponent.vue?vue&type=script&lang=ts"
import style0 from "./SuccessComponent.vue?vue&type=style&index=0&id=1f7a28ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7a28ba",
  null
  
)

export default component.exports